import { render, staticRenderFns } from "./List-Shipment-Statuses.vue?vue&type=template&id=6815e862"
import script from "./List-Shipment-Statuses.vue?vue&type=script&lang=js"
export * from "./List-Shipment-Statuses.vue?vue&type=script&lang=js"
import style0 from "./List-Shipment-Statuses.vue?vue&type=style&index=0&id=6815e862&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports